// extracted by mini-css-extract-plugin
module.exports = {"actionBtn":"SwipeList_actionBtn__RMzT9","list":"SwipeList_list__Ry_ag","page":"SwipeList_page__F8TqS"};